import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/radar-chart/pages/CalculatorPage";

export const Route = createFileRoute("/radar-chart")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/radar-chart",
      title: m.radar_meta_title(),
      description: m.radar_meta_description(),
      toolName: m.radar_tool_name(),
      faqs: [
        { q: m.radar_faq_q1(), a: m.radar_faq_a1() },
        { q: m.radar_faq_q2(), a: m.radar_faq_a2() },
        { q: m.radar_faq_q3(), a: m.radar_faq_a3() },
        { q: m.radar_faq_q4(), a: m.radar_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
